import { ResourceVm } from 'qp-ui-interface';
import { ConfigService } from '../services/config/config.service';
// TODO: Parental control levels
// export const getAllowLevels = (parentalLevels: ParentalControlLevels[], ageGroup: string): string[] => {
//   const allowedLeveles = [] as Array<string>;
//   let isAgeGroup = false;
//   parentalLevels?.forEach((value) => {
//     if (!isAgeGroup) {
//       allowedLeveles.push(value.name.replace(/\s/g, ''));
//     }
//     if (value.name.replace(/\s/g, '') === ageGroup) isAgeGroup = true;
//   });
//   return allowedLeveles;
// };

/**
 * Check if the resource ratings is included in the config explicit ratings comma separated array
 *
 * @param configService
 * @param resource
 * @returns
 */
export const isExplicitContent = (configService: ConfigService, resource: ResourceVm): boolean => {
  const explicitContent = configService.applicationConfig.modalExplicitContentRatings.split(',').map((e) => e.toLowerCase());
  if (!resource) return false;
  if (!resource.ratings) return false;
  if (resource.ratings.length <= 0) return false;
  return !!resource.ratings.find((rating) => explicitContent.includes(rating.v.toLowerCase()));
};
